export const RepresentativeType = {
  UNIVERSITY_REPRESENTATIVE: "UNIVERSITY_REPRESENTATIVE",
  COMPANY_REPRESENTATIVE: "COMPANY_REPRESENTATIVE",
};
